import { createTheme } from "@mui/material/styles";
export const ui_colors = {
  primary: "#3567D6",
  secondary: "#3CD0FF",
  primaryBack: "#F5F2F0",
  secondaryBack: "#F7F6F6",
  semiPrimary: "#f5f9ff",
  textPrimary: "#7F7F7F",
  lightGray: "#D9D9D9",
  pending: "#F7B217",
  error: "#ff0000",
  white: "#fff",
};

export const border = (width = 1) => `${width}px solid #${ui_colors.lightGray}`;

export const theme = createTheme({
  typography: {
    allVariants: {
      fontFamily: `'IBM Plex Sans', 'Catamaran', Inter`,
    },
  },

  palette: {
    primary: {
      main: ui_colors.primary,
    },
    secondary: {
      main: ui_colors.secondary,
    },
    error: {
      main: ui_colors.error,
    },
  },

  components: {
    MuiSkeleton: {
      defaultProps: {
        animation: "pulse",
      },
    },

    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          scale: "1.1",
          padding: "8px",

          // textTransform: "capitalize",
        },
      },
    },

    MuiTypography: {
      styleOverrides: {
        h1: {
          fontFamily: "Catamaran",
          fontSize: "24px",
          fontWeight: "500",
        },
        h2: {
          fontFamily: "Catamaran",
          fontSize: "22px",
          fontWeight: "500",
          width: "fit-content",
          display: "inline-block",
        },
        h3: {
          color: "#212529",
          fontFamily: "Catamaran",
          fontSize: "20px",
          fontWeight: "500",
          width: "fit-content",
          display: "inline-block",
        },
        h4: {
          fontFamily: "Catamaran",
          fontSize: "18px",
          fontWeight: "700",
        },
        h5: {
          fontFamily: "Catamaran",
          fontSize: "40px",
          fontWeight: "700",
          display: "inline-block",
        },
        h6: {
          fontFamily: "Catamaran",
          fontSize: "40px",
          fontWeight: "500",
          display: "inline-block",
        },
        h7: {
          fontFamily: "Catamaran",
          fontSize: "30px",
          fontWeight: "800",
        },
        h8: {
          fontFamily: "Catamaran",
          fontSize: "20px",
          fontWeight: "500",
          display: "block",
        },
        h9: {
          fontFamily: "Catamaran",
          fontSize: "18px",
          fontWeight: "500",
          color: "#444750",
        },

        body1: {
          color: "#495057",
          fontFamily: "Catamaran",
          fontSize: "22px",
          fontStyle: "normal",
          fontWeight: "400",
          lineHeight: "normal",
          display: "inline-block",
        },
        body2: {
          color: "#3567D6",
          fontFamily: "Catamaran",
          fontSize: "20px",
          fontStyle: "normal",
          fontWeight: "500",
        },
        body3: {
          color: "#000000",
          fontFamily: "Catamaran",
          fontSize: "18px",
          fontStyle: "normal",
          fontWeight: "500",
        },
        body4: {
          color: "#000000",
          fontFamily: "Catamaran",
          fontSize: "16px",
          fontStyle: "normal",
          fontWeight: "500",
        },
        body5: {
          color: "#6D6D6D",
          fontFamily: "Catamaran",
          fontSize: "14px",
          fontStyle: "normal",
          fontWeight: "400",
          display: "block",
        },
        body6: {
          color: "#000000",
          fontFamily: "Catamaran",
          fontSize: "14px",
          fontStyle: "normal",
          fontWeight: "400",
        },
        body7: {
          color: "#000000",
          fontFamily: "Catamaran",
          fontSize: "12px",
          fontStyle: "normal",
          fontWeight: "400",
          display: "block",
        },

        body8: {
          color: "#3A454A",
          fontFamily: "Catamaran",
          fontSize: "16px",
          fontWeight: "500",
          display: "block",
        },
        body9: {
          color: "#242E49",
          fontFamily: "Catamaran",
          fontSize: "15px",
          fontWeight: "400",
        },
        body10: {
          fontFamily: "Poppins",
          fontSize: "15px",
          fontWeight: "400",
        },
      },
    },

    MuiDialogTitle: {
      styleOverrides: {
        root: {
          fontWeight: 600,
        },
      },
    },

    MuiTabs: {
      styleOverrides: {
        root: {
          width: "100%",
          fontFamily: "Catamaran",
          fontSize: "16px",
          fontStyle: "normal",
          fontWeight: "500",
          lineHeight: "normal",
          justifyContent: "space-between",
        },
      },
    },

    MuiButton: {
      styleOverrides: {
        root: {
          textAlign: "center",
          fontFamily: "Catamaran",
          fontSize: "14px",
          fontWeight: "400",
          padding: "4px 16px",
          borderRadius: "8px",
          boxShadow: "none",
          textTransform: "none",
          background: "#3567D6",
          color: "#fff",
          border: "none",
          lineHeight: "normal",
          ":hover": {
            color: "#000000",
            background: ui_colors.secondary,
          },
        },
        small: {
          padding: "6px 18px",
          fontSize: "14px",
        },

        outlined: {
          color: ui_colors.primary,
          background: "#fff",
          border: `1px solid ${ui_colors.primary}`,
          borderColor: ui_colors.primary,
          ":hover": {
            boxShadow: "none",
            background: ui_colors.primary,
            color: ui_colors.white,
          },
        },

        dark: {
          background: "#3B475D",
          color: "white",
          fontSize: "14px",
          padding: "6px 10px",
          ":hover": {
            background: "#2c3649",
            color: "white",
            padding: "4px 8px 4px 8px",
            boxShadow: `0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)`,
          },
        },
        mobile: {
          color: "#FFF",
          background: "#3567D6",
          fontSize: "14px",
          textAlign: "center",
          fontFamily: "IBM Plex Sans",
          fontWeight: "400",
          lineHeight: "130%",
          letterSpacing: "0.03px",
          display: "inline-flex",
          padding: "4px 4px 4px 24px",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "12px",
          textDecoration: "capitalize",
          borderRadius: "12px",
          transition: "all 200ms !important",
          boxShadow: "none",
          height: 48,
          width: "fit-content",
        },
        custom_msg: {
          textAlign: "center",
          fontFamily: "Catamaran",
          background: ui_colors.primary,
          borderRadius: "12px",
          color: "#fff",
          padding: "6px 20px",
          fontSize: "16px",
          textTransform: "none",
          ":hover": {
            color: "#000000",
            background: ui_colors.secondary,
          },
        },
        products: {
          color: "#1E1E1E",
          fontSize: "14px",
          padding: "4px 8px 4px 8px",
          ":hover": {
            boxShadow: "none",
            background: "transparent",
          },
        },
        outlined_red: {
          color: ui_colors.error,
          background: "#fff",
          boxShadow: "inset 0px 0px 0px 1px #ff0000",
          ":hover": {
            boxShadow: "inset 0px 0px 0px 1px #ff0000",
          },
        },
        text: {
          boxShadow: "none",
        },
      },
    },
  },
});
